export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const RESET_DATE_RANGE = 'RESET_DATE_RANGE';
export const SET_DASHBOARD_ACTIVE_TAB = 'SET_DASHBOARD_ACTIVE_TAB';
export const SET_ASSETS_DISTRIBUTION_TAB = 'SET_ASSETS_DISTRIBUTION_TAB';
export const SET_ASSETS_SELECTION = 'SET_ASSETS_SELECTION';
